module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_vm._l((_vm.row.subject_list), function(subject, index) {
    return _c('div', [_c('el-divider', [_vm._v("项目信息" + _vm._s(index + 1))]), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "项目",
        "prop": "name"
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": "",
        "type": "text",
        "placeholder": "请输入单位名称"
      },
      model: {
        value: (subject.subject_name),
        callback: function($$v) {
          _vm.$set(subject, "subject_name", $$v)
        },
        expression: "subject.subject_name"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "参赛运动员",
        "prop": "type"
      }
    }, _vm._l((subject.yundongyuan), function(yundongyuan, index) {
      return _c('el-tag', {
        key: index,
        staticStyle: {
          "margin-right": "10px"
        },
        attrs: {
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(_vm._f("sex")(yundongyuan.sex)) + "\n              ")])
    }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "替补运动员",
        "prop": "tbydy"
      }
    }, _vm._l((subject.tbydy), function(yundongyuan, index) {
      return _c('el-tag', {
        key: index,
        staticStyle: {
          "margin-right": "10px"
        },
        attrs: {
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(_vm._f("sex")(yundongyuan.sex)) + "\n              ")])
    }), 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(!subject.music_url) ? _c('el-form-item', {
      attrs: {
        "label": "自选音乐",
        "prop": "grade"
      }
    }, [_c('FileUploader', {
      attrs: {
        "fileList": subject.music,
        "limit": 1,
        "accept": '.mp3'
      }
    })], 1) : _c('el-form-item', {
      attrs: {
        "label": "规定音乐"
      }
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.playMusicUrl = subject.music_url;
          _vm.showMusic = true
        }
      }
    }, [_vm._v("点击试听 "), _c('i', {
      staticClass: "el-icon-arrow-right"
    })])])], 1)], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "教练员",
        "prop": "jiaolian"
      }
    }, _vm._l((subject.jiaolian), function(yundongyuan, index) {
      return _c('el-tag', {
        key: index,
        staticStyle: {
          "margin-right": "10px"
        },
        attrs: {
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(_vm._f("sex")(yundongyuan.sex)) + "\n              ")])
    }), 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存\n          ")]), _vm._v(" "), (false) ? _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")]) : _vm._e()], 1)], 1)], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "音乐播放",
      "visible": _vm.showMusic
    },
    on: {
      "update:visible": function($event) {
        _vm.showMusic = $event
      },
      "close": function($event) {
        _vm.showMusic = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.playMusicUrl && _vm.showMusic) ? _c('audio', {
    staticStyle: {
      "margin": "10px auto"
    },
    attrs: {
      "autoplay": "",
      "src": _vm.playMusicUrl,
      "controls": "controls"
    }
  }) : _vm._e()])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31ad2109","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep2Music.vue
// module id = 1433
// module chunks = 0